import { RouteHttpVerb } from "@devowl-wp/utils";
export var locationRestConsentDynamicPredecisionGet = {
  path: "/consent/dynamic-predecision",
  method: RouteHttpVerb.GET
};